import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { locale as employeeCostsIt } from "./i18n/employeeCostsIt";
import { RouterModule } from "@angular/router";
import { ContentHeaderModule } from "../../layout/components/content-header/content-header.module";
import { NgSelectModule } from "@ng-select/ng-select";
import { TranslateModule } from "@ngx-translate/core";
import { CoreCommonModule } from "../../../@core/common.module";
import { PerfectScrollbarModule } from "ngx-perfect-scrollbar";
import { CoreCardModule } from "../../../@core/components/core-card/core-card.module";
import { customBreakPointsProvider } from "../../layout/custom-breakpoints";
import { UpdateEmployeeCostsComponent } from "./pages/update-real-costs/update-employee-costs.component";
import employeeCostsRoutes from "./employee-costs.routes";
import employeeCostsMenu from "./employee-costs.menu";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import employeeCostsSettingsLinks from "./employee-costs.settings-links";
import { ListEmployeesCostsComponent } from "./pages/list-employees-costs/list-employees-costs.component";
import { UpdateContractCostsComponent } from "./pages/update-contract-costs/update-contract-costs.component";
import { NgbAlertModule } from "@ng-bootstrap/ng-bootstrap";
import { UtilsService } from "../../auth/service/utils.service";
import EmployeeTfrAmountComponent from './pages/employee-tfr-amount/employee-tfr-amount.component';

@NgModule({
  declarations: [UpdateEmployeeCostsComponent, ListEmployeesCostsComponent, UpdateContractCostsComponent, EmployeeTfrAmountComponent],
  imports: [CoreCardModule, CommonModule, ContentHeaderModule, RouterModule.forChild(employeeCostsRoutes), NgSelectModule, TranslateModule, CoreCommonModule, PerfectScrollbarModule, NgxDatatableModule, NgbAlertModule],
  providers: [customBreakPointsProvider],
})
export class EmployeeCostsModule {
  constructor(private _utilService: UtilsService) {
    this._utilService.initModule("employee-costs", employeeCostsIt, employeeCostsMenu, employeeCostsSettingsLinks);
  }
}
